module.exports = __webpack_public_path__ + "images/0971141b6b481daa2b96b18c5bf66453.png";